'use client';

import { type FC } from 'react';
import { DefaultHeader } from './DefaultHeader';
import { MinimalHeader } from './MinimalHeader';
import { PaceId } from './PaceId';
import { useCopiedDynamicYieldCookie } from './useCopiedDynamicYieldCookie';

export type HeaderProps = {
  isMinimal?: boolean;
};

export const Header: FC<HeaderProps> = ({ isMinimal }) => {
  useCopiedDynamicYieldCookie();

  return (
    <>
      <PaceId />
      {isMinimal ? <MinimalHeader /> : <DefaultHeader />}
    </>
  );
};
